//
// Model.
//
export var FoundLinkType;
(function (FoundLinkType) {
    FoundLinkType["TAG"] = "TAG";
    FoundLinkType["BLOB"] = "BLOB";
    FoundLinkType["ENTITY"] = "ENTITY";
    FoundLinkType["RECORD"] = "RECORD";
    FoundLinkType["VERSION"] = "VERSION";
})(FoundLinkType || (FoundLinkType = {}));
